var axios = require('axios')
const urlTenant = process.env.version + '/product-tenant'
const urlPaymentMethod = process.env.version + '/product-payment-fe/payment-methods'
const urlMessage = process.env.version + '/product-tenant/error-messages'

axios.getSocialByClient = function (param, success, callBackError) {
  this.get(urlTenant + '/config', {params: param})
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getConfigFromTenant = function (param, success, callBackError) {
  this.get(urlTenant + '/config', {params: param})
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getPaymentMethod = function (param, success, callBackError) {
  this.get(urlPaymentMethod, {params: param})
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getErrorMessage = function (params, success, callBackError) {
  this.get(urlMessage, { params: params }).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getConfigByClient = function (param, success, callBackError) {
  this.get(urlTenant + '/config', {params: param})
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

export default axios



// WEBPACK FOOTER //
// ./src/api/Tenant.js